import './float-banner.scss'
import { EventBus } from 'js/utility/event-bus.js'

export default {
    name: 'float-banner',

    data: {
        display: 'hidden'
    },

    mounted() {
        const sessionBannerDisplay = sessionStorage.getItem('coopBannerDisplay')
        if (['visible', 'hidden'].includes(sessionBannerDisplay)) {
            this.display = sessionBannerDisplay
        } else {
            this.display = 'visible'
        }
    },

    methods: {
        close() {
            this.display = 'hidden'
            sessionStorage.setItem('coopBannerDisplay', 'hidden')
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/float-banner/float-banner.js